import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generated class for the RmtGroupItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-group-item',
  templateUrl: 'rmt-group-item.html',
})
export class RmtGroupItemComponent {
  text: string;

  @Input() private title: string;
  @Input() titleStyle: string;
  @Input() private subtitle1: string;
  @Input() private rate: number;
  @Input() private promoRate: number;
  @Input() private sendCurrency: string;
  @Input() private receiveCurrency: string;
  @Input() private button: string;
  @Input() private buttonType: string = "chevron";
  @Input() private promo: any;
  @Input() private minimumElements = 4;
  @Input() private img: string;
  @Input() private isPremiumRate: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() itemsList: any[]
  @Output() itemEmitter = new EventEmitter();
  @Output() clickButton = new EventEmitter();
  @Output() clickBubble = new EventEmitter();

  constructor() {
  }

  clickBubbleEvent(ev) {
    this.clickBubble.emit(ev);
  }

  select(ev) {
    this.itemEmitter.emit(ev);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-group-item/rmt-group-item.ts